type Target = `product-${'eshop' | 'rental' | 'season'}` | `category-${'eshop' | 'rental'}`

export default function linkTo(target: Target, code: string | number, slug?: string) {
    switch (target) {
        case 'category-eshop':
            return linkToCategoryEshop(code, slug)
        case 'category-rental':
            return linkToCategoryRental(code, slug)
        case 'product-eshop':
            return linkToProductEshop(code.toString(), slug)
        case 'product-rental':
            return linkToProductRental(code.toString(), slug)
        case 'product-season':
            return ''
    }
}

export const linkToProductEshop = (code: string, slug?: string) => `/produkty/detail/${code}${slug ? `-${slug}` : ''}`
export const linkToProductRental = (code: string, slug?: string) => `/pujcovna/detail/${code.replace('|', '/')}${slug ? `-${slug}` : ''}`
export const linkToCategoryEshop = (code: string | number, slug?: string) => `/produkty/vypis/${code}${slug ? `-${slug}` : ''}`
export const linkToCategoryRental = (code: string | number, slug?: string) => `/pujcovna/vypis/${code}${slug ? `-${slug}` : ''}`

export const createLinkToChangeBranch = (branchSlug: string) => `/pobocka-${branchSlug}${location.pathname.replace(/\/pobocka[a-z-]+/, '')}${window.location.search}`
